import { render, staticRenderFns } from "./SfContentPages.vue?vue&type=template&id=0f4c5b0e&"
import script from "./SfContentPages.vue?vue&type=script&lang=js&"
export * from "./SfContentPages.vue?vue&type=script&lang=js&"
import style0 from "./SfContentPages.vue?vue&type=style&index=0&id=0f4c5b0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports